module.exports = __webpack_public_path__ + "img/SP-Profi_Overview-Front_2.13f4c89c.jpg";